import React, { useEffect, useState } from "react";
import BillingHistory from "../../components/DashBoard/Payment/BillingHistory";
import { notification } from "antd";
import { getBillingHistory } from "../../services/PaymentService/PaymentTransactionService";
import { useBillingHistoryCtx } from "../../context/BillingHistoryContext";
import { RefundTransactionReasons } from "../../types/PaymentTransactionTypes";
import { getLookupListByListName } from "../../services/RegistrationService";
import { usePersonSummaryCtx } from "../../context/PersonSummaryContext";
import moment from "moment";

const BillingHistoryContainer = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    dateRangeCtx,
    billingHistoryCtx,
    filteredTransactionTypesCtx,
    refundTransactionReasonsCtx,
    billingHistoryForceRefetchCtx,
  } = useBillingHistoryCtx();

  const [billingHistory, setBillingHistory] = billingHistoryCtx;
  const [dateRange] = dateRangeCtx;
  const [filteredTransactionTypes] = filteredTransactionTypesCtx;
  const [
    refundTransactionReasons,
    setRefundTransactionReasons,
  ] = refundTransactionReasonsCtx;
  const [forceRefetch] = billingHistoryForceRefetchCtx;

  const {
    caregiverSummaryInfo,
    isWandaConcierge,
    isLoadingPersonData,
  } = usePersonSummaryCtx();

  useEffect(() => {
    setIsLoading(true);
    const fetchBillingHistory = async () => {
      try {
        const response = await getBillingHistory({
          CustomerPersonId: isWandaConcierge
            ? caregiverSummaryInfo.personId
            : undefined,
          StartDate: moment
            .utc(dateRange.startDate)
            .startOf("day")
            .format(),
          EndDate: moment
            .utc(dateRange.endDate)
            .endOf("day")
            .format(),
          PageOffset: 1,
          PageSize: 1000,
          PaymentTransactionTypeIds: filteredTransactionTypes,
        });
        setBillingHistory(response);
      } catch (error) {
        notification.error({
          message: "Error",
          description: "Failed to Fetch Billing History",
        });
      } finally {
        setIsLoading(false);
      }
    };

    !isLoadingPersonData && fetchBillingHistory();
  }, [dateRange, filteredTransactionTypes, forceRefetch, isLoadingPersonData]);

  useEffect(() => {
    isWandaConcierge &&
      !refundTransactionReasons &&
      (async () => {
        try {
          const apiResponse = await getLookupListByListName(
            1,
            RefundTransactionReasons.SubscriptionPaymentTransactionRefundReason
          );
          const reasons = apiResponse.map(
            (response: { itemId: number; itemName: string }) => ({
              value: response.itemId,
              label: response.itemName,
            })
          );
          setRefundTransactionReasons(reasons);
        } catch (error) {
          notification.error({
            message: "Error",
            description: "Failed to Fetch Refund Reasons",
          });
        }
      })();
  }, []);

  return <BillingHistory dataSource={billingHistory} isLoading={isLoading} />;
};
export default BillingHistoryContainer;
